<button mat-icon-button (click)="linkIconClicked();$event.stopPropagation()">
  <mat-icon [ngClass]="iconStatus ? 'linked' : 'unlinked'"
            [matTooltipDisabled]="!params.data?.isLinked"
            [matTooltip]="toolTip">link</mat-icon>
</button>